import { setVehicleList } from "../../../store/slices/vehicleSlice";

export default function responseFetchAllVehicles(response: any, api: any, arg: any) {
    console.log('[API Response] Vehicles fetched, raw response type:', typeof response, 'is array:', Array.isArray(response));
    console.log('[API Response] Response structure:', {
        isDirectArray: Array.isArray(response),
        hasDataProperty: response?.data !== undefined,
        hasPagination: response?.pagination !== undefined,
        respondKeys: response ? Object.keys(response).slice(0, 5) : 'null'
    });

    // Handle both direct array (legacy), wrapped in .data (legacy), and new pagination format
    let vehicleData: any[] = [];
    let paginationInfo = null;

    if (Array.isArray(response)) {
        // Direct array response from API (legacy)
        vehicleData = response;
        console.log('[API Response] Using direct array response:', response.length, 'vehicles');
    } else if (response?.data && Array.isArray(response.data)) {
        // Wrapped in .data property (legacy format)
        vehicleData = response.data;
        console.log('[API Response] Using response.data:', response.data.length, 'vehicles');
        console.log('[API Response] Pagination info:', response.pagination);
        paginationInfo = response.pagination;
    } else if (response?.data?.data && Array.isArray(response.data.data)) {
        // Double-wrapped by RTK Query: { data: { data: [...], pagination: {...} } }
        vehicleData = response.data.data;
        console.log('[API Response] Using response.data.data:', response.data.data.length, 'vehicles');
        console.log('[API Response] Pagination info:', response.data.pagination);
        paginationInfo = response.data.pagination;
    } else if (response?.data && typeof response.data === 'object') {
        // Pagination format: { data: [...], pagination: {...} }
        // RTK Query wraps as { data: { data: [...], pagination: {...} } }
        vehicleData = response.data.data || [];
        paginationInfo = response.data.pagination || null;
        console.log('[API Response] Using pagination format, vehicles:', vehicleData.length, 'pagination:', paginationInfo);
    } else {
        console.warn('[API Response] Unexpected response format:', response);
        vehicleData = [];
    }

    console.log(`[API Response] Dispatching ${vehicleData.length} vehicles to Redux store`);
    api.dispatch(setVehicleList(vehicleData));
    // Return the full response for components to access pagination info
    return response;
}